import React, { useEffect, useRef, useState } from 'react';

import { LoadingButton } from '@atlaskit/button';
import { createAccountsMapping } from 'src/services/accountsMapping';
import { useMyUserMapping } from 'src/services/myUserMapping';

import { trackEvent } from 'src/lib/analytics';
import pagerduty from 'src/lib/api/pagerduty';

import ErrorMessage from 'src/views/components/ErrorMessage';

import OtherConnectedAccounts from '../../components/OtherConnectedAccounts';

const createPagerDutyExtension = async () => {
  const { accounts_addons } = await pagerduty.getAccountsAddons({ addon_key: 'com.pagerduty.jiraserver' });
  if (Array.isArray(accounts_addons) && accounts_addons.length > 0) return;
  await pagerduty.createJiraServerV3AccountsAddon();
};

const CreateAccountsMapping = () => {
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState(null);
  const { loading, mappingBasedOnSessionDetails, error: mappingError } = useMyUserMapping();

  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const onConnect = async () => {
    const setErrorSafe = (val) => mounted.current && setError(val);
    const setConnectingSafe = (val) => mounted.current && setConnecting(val);
    if (error) setErrorSafe(null);
    setConnectingSafe(true);

    try {
      await createPagerDutyExtension()
        .catch(e => Promise.reject(['Failed to create PagerDuty Extension', e]));

      await createAccountsMapping(mappingBasedOnSessionDetails)
        .catch(e => Promise.reject(['Failed to connect accounts', e]));

      trackEvent('settings_integration', { label: 'connect_account' });
    } catch (e) {
      setErrorSafe(e);
    }

    setConnectingSafe(false);
  };

  return (
    <div data-cy="top-level-create-accounts-mapping">
      <br/>
      {mappingError && <ErrorMessage error={['Can not get current users details:', mappingError]}/>}
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoadingButton appearance="primary" onClick={onConnect} isLoading={connecting} isDisabled={Boolean(mappingError) || loading}>Connect Jira to PagerDuty{error ? ' (retry)' : ''}</LoadingButton>
      </div>
      <br/>
      {error && <ErrorMessage error={error}/>}
      <br/>
      <OtherConnectedAccounts/>
    </div>
  );
};

export default CreateAccountsMapping;
